import React from "react";
import dark_photo_1 from "../img/my-dark-photo-1.jpg";

const About = () => {
  return (
    <>
      <section className="about">
        <div className="row">
          <h1 className="heading">About Me</h1>
          <div className="about__content">
            {/* <figure className="about__img">
              <img src="./img/profile-photo.png" alt="Maruf Mia" />
            </figure> */}
            <h3 className="heading mb-3">
              <span className="about__text--1">
                I am a creative front-end developer with over 2 years of
                experience building beautiful and functional websites. I am
                skilled in HTML, CSS, JavaScript, React.js, Next.js, Redux
                (toolkit), Gsap, and Tailwind. and familiar with Vue, Nuxt and
                Wordpress (customization with Elementor).
              </span>

              {/* <span className="about__text--2">Now I Am A Full-Time Learner.</span> */}
              <span className="about__text--2 text">
                I am always looking for new challenges and opportunities to
                learn and grow. I believe in giving back to the community and
                enjoy helping others develop their skills as developers.
              </span>
            </h3>

            <div className="history mt-10">
              <h2 className="heading">Work History</h2>
              <div className="history__company">
                <div className="nav">
                  <h4 className="heading">Devute (frontend developer)</h4>
                  <p className="small-text">Dec 2022 - current</p>
                </div>
                <ul className="mb-4 details">
                  <li className="mb-2">
                    <p className="text">Selected Projects at Devute:</p>
                    <ul>
                      <li>
                        <a href="https://devute.com" target="_blank">
                          Devute:
                        </a>
                        Built using Next.js, Redux, and Bootstrap. Collaborated
                        closely with the backend team for seamless
                        functionality. devute.com
                      </li>
                      <li>
                        Digitaltechs: Created with Next.js, Redux Toolkit,
                        Bootstrap, and Sass. Managed frontend-backend
                        integration to ensure a cohesive user experience.
                      </li>
                    </ul>
                  </li>
                  <li>
                    <p className="text">
                      Projects Using WordPress and Elementor:
                    </p>
                    <ul>
                      <li>
                        <a href="https://ecclbd.com/" target="_blank">
                          ECCLBD:
                        </a>
                        Developed a custom WordPress website, utilizing
                        Elementor for page building and design customization.
                      </li>
                      <li>
                        <a
                          href="https://royaltychauffeurs.co.uk/"
                          target="_blank">
                          Royalty Chauffeurs:
                        </a>
                        Customized a WordPress theme to develop a professional
                        website for Royalty Chauffeurs. Utilized Elementor for
                        design customization and enhanced user experience.
                      </li>
                      <li>
                        <a
                          href="https://devute.xyz/projects/2024-projects/01-2024/team-consultancy/"
                          target="_blank">
                          Team Consultency:
                        </a>
                        Contributed to converting designs from Figma and
                        customizing functionalities for an LMS project. Added
                        custom code for various functionalities.
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              <div className="history__company">
                <div className="nav">
                  <h4 className="heading">Freelance Web Developer</h4>
                  <p className="small-text">Jul 2021 - current</p>
                </div>
                <ul className="details">
                  <li>
                    Created over 60 plus web applications, ranging from
                    single-page websites to fully functional web apps.
                  </li>
                  <li className="mb-4">
                    <h4 className="text">ThemeForest:</h4>
                    <ul>
                      <li>
                        <a
                          href="https://themeforest.net/item/xhibiter-nft-marketplace-react-next-template/39385960"
                          target="_blank">
                          Xhibitar:
                        </a>
                        Themeforest React and Next.js NFT Template, Created
                        using Next.js, Tailwind CSS, and Redux Toolkit.
                      </li>
                      <li>
                        <a
                          href="https://themeforest.net/item/patrick-personal-cv-vcard-react-template/35737202"
                          target="_blank">
                          Patrick:
                        </a>
                        Themeforest React Portfolio Template, Designed and
                        developed a React-based personal CV/portfolio template.
                      </li>
                      <li>
                        <a
                          href="https://themeforest.net/item/maria-model-designer-portfolio-template/21604495"
                          target="_blank">
                          Maria:
                        </a>
                        Themeforest HTML Portfolio Template, Crafted an HTML
                        portfolio template using HTML, CSS, Sass, Bootstrap, and
                        jQuery plugins.
                      </li>
                    </ul>
                  </li>

                  <li className="mb-4">
                    <h4 className="text">FutureINV Agency:</h4>
                    <ul>
                      <li>
                        <a
                          href="https://themeforest.net/item/maria-model-designer-portfolio-template/21604495"
                          target="_blank">
                          Maria:
                        </a>
                        Themeforest HTML Portfolio Template, Crafted an HTML
                        portfolio template using HTML, CSS, Sass, Bootstrap, and
                        jQuery plugins.
                      </li>
                      <li>
                        <a href="https://colonpax.com/" target="_blank">
                          Colonpax:
                        </a>
                        Developed for FutureINV agency using React, Redux
                        Toolkit, and CSS. Enhanced user experience and
                        interface, ensuring responsiveness and performance
                        optimization.
                      </li>
                    </ul>
                  </li>

                  <li>
                    <h4 className="text">Hablu Programmer:</h4>
                    <ul>
                      <li>
                        <p className="text">
                          Selected Projects Using Next.js and Tailwind CSS
                        </p>
                      </li>
                      <li>
                        <a href="https://prodrive.vercel.app/" target="_blank">
                          Prodrive:
                        </a>
                        Developed a web application with a focus on performance
                        and user experience.
                      </li>
                      <li>
                        <a href="https://www.rivusdao.xyz/" target="_blank">
                          Rivus DAO:
                        </a>
                        Created a decentralized application, ensuring responsive
                        design and seamless functionality.
                      </li>
                      <li>
                        <a
                          href="https://www.kiekefotografie.nl/"
                          target="_blank">
                          Kieke Fotografie:
                        </a>
                        Built a photography portfolio site with a clean and
                        modern interface.
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
